module.exports = __webpack_public_path__ + "img/waterNo.ecb386db.png";